export enum Sentiment {
  Negative = 'negative',
  Neutral = 'neutral',
  Positive = 'positive',
}
